import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { LANGUAGES } from '../constants';
import { getTranslation } from '../i18n/translations';

const I18nContext = createContext();

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};

export const I18nProvider = ({ children }) => {
  // 从localStorage读取保存的语言设置，默认为'en'
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'en';
  });

  // 当语言改变时，保存到localStorage
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  const t = useCallback((key, variables = {}) => {
    const translation = getTranslation(key, language, variables);
    return translation;
  }, [language]);

  const value = {
    language,
    changeLanguage,
    setLanguage,
    languages: LANGUAGES,
    t
  };

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
};